<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>해상배상책임보험</li>
					<li>해상배상책임보험의 개요</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>해상배상책임보험의 개요</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<div class="conStyle1">
						<p class="tit mgt0">상품개요</p>
						<p class="txt">물류 산업의 세분화에 따른 운송 및 물류 사업자의 다양한 배상 책임을 종합적으로 담보하는 보험 상품으로 담보 내용 및 가입 대상은 아래와 같습니다.</p>
						<ol class="num">
							<li>
								보험담보
								<ul class="line">
									<li>해상 및 육상을 포함하여 화물의 운송 및 물류와 관련된 사업자가 운송인 또는 물류업자로서 부담해야 하는 법률상 배상책임 및 공동해손, 구조비 등을 담보함</li>
								</ul>
							</li>
							<li>
								가입대상
								<ul class="line">
									<li>화물의 해상 운송 및 보관, 육상 운송 및 물류 과정에서 발생 될 수 있는 배상 책임 위험에 노출된 사업자로서, 해상/육상 운송사업자, 무선박 운송업자(NVOCC), 소화물 운송인, 화물운송 주선인(Forwarder), 창고업자, 용선자, 항만 및 터미널 시설 운영자 선박 대리점 등이 대표적인 가입 대상임</li>
								</ul>
							</li>

						</ol>

						<p class="tit">용어에 대한 이해</p>
						<ol class="num">
							<li>통운송계약과 복합운송계약
								<ul class="line">
									<li>통운송계약(contract of through carriage)이란, 단일의 운송에서 2인 이상의 운송인이 참여하는 운송 형태로서 흔히 육상, 해상, 항공 통운송으로 구별됨. 실제로는 각 구간별로 운송 수단을 달리하여 여러 운송이 결합하는 경우가 많은데, 이처럼 운송 수단을 달리하는 통운송을 복합운송이라 함.</li>
								</ul>
							</li>
							<li>하역업자(Stevedore) 위험
								<ul class="line">
									<li>하역(선내/선측 작업 포함) 중 화물/컨테이너/설비 또는 제3자의 재산에 대한 물리적 멸실 손상</li>
									<li>상기의 사유로 인한 간접 손해 및 영업중단손실</li>
									<li>하역 또는 보관 업부 수행 중 발생 한 제3자에 대한 신체적 손상</li>
									<li>공동해손, 구조료 또는 구조비에 대한 화물 분담액</li>
									<li>세관 또는 관련 법규의 위반에 따른 벌과금</li>
								</ul>
							</li>
							<li>도로운송업자(inland transportation) 위험
								<ul class="line">
									<li>운송인 또는 이행 보조인의 보호, 보관 또는 관리하에 있는 화물에 대한 또는 화물로부터 야기된 물리적 멸실 또는 손상</li>
									<li>상기의 사유로 인한 간접 손해 및 영업중단손실</li>
									<li>세관 또는 관련 법규의 위반에 따른 벌과금</li>
								</ul>
							</li>
							<li>운송주선인(Freight forwarder / NVOCC) 또는 물류업자(Warehousing/ Packing) 위험
								<ul class="line">
									<li>보호, 보관 또는 관리하에 있는 화물에 대한 물리적 멸실 또는 손상</li>
									<li>과실 또는 작위/부작위에 따른 화물의 손상을 포함한 Error &amp; Omission liability</li>
									<li>상기의 사유로 인한 간접 손해 및 영업중단손실</li>
								</ul>
							</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

</script>

<style>

</style>
